/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './MyFatoorahPaymentDataServiceEntities.g';

// @ts-ignore
function orderExtControllerQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('OrderExtController', 'VSICategoryEXT', DataServiceEntities.VSICategoryEXTExtensionClass, key);
}

export function createInitiatePaymentInput(invoiceAmount: number, currencyIso: string): IDataServiceRequest {
    const query = orderExtControllerQuery();
    return query.createDataServiceRequestForOperation(
        'InitiatePayment',
        true,
        DataServiceEntities.InitiatePaymentResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IInitiatePaymentResponse' },
        { invoiceAmount: invoiceAmount, currencyIso: currencyIso }
    );
}

export function initiatePaymentAsync(
    context: IContext,
    invoiceAmount: number,
    currencyIso: string
): AsyncResult<DataServiceEntities.IInitiatePaymentResponse> {
    const request = createInitiatePaymentInput(invoiceAmount, currencyIso);
    return callActionOrExecute<DataServiceEntities.IInitiatePaymentResponse>(request, context.callerContext);
}

export function createGetPaymentStatusInput(key: string, keyType: string): IDataServiceRequest {
    const query = orderExtControllerQuery();
    return query.createDataServiceRequestForOperation(
        'GetPaymentStatus',
        true,
        DataServiceEntities.GetPaymentStatusResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetPaymentStatusResponse' },
        { key: key, keyType: keyType }
    );
}

export function getPaymentStatusAsync(
    context: IContext,
    key: string,
    keyType: string
): AsyncResult<DataServiceEntities.IGetPaymentStatusResponse> {
    const request = createGetPaymentStatusInput(key, keyType);
    return callActionOrExecute<DataServiceEntities.IGetPaymentStatusResponse>(request, context.callerContext);
}

export function createExecutePaymentInput(
    paymentMethodId: number,
    customerName: string,
    displayCurrencyIso: string,
    mobileCountryCode: string,
    customerMobile: string,
    customerEmail: string,
    invoiceValue: number,
    callBackUrl: string,
    errorUrl: string,
    language: string,
    customerReference: string
): IDataServiceRequest {
    const query = orderExtControllerQuery();
    return query.createDataServiceRequestForOperation(
        'ExecutePayment',
        true,
        DataServiceEntities.ExecutePaymentResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IExecutePaymentResponse' },
        {
            paymentMethodId: paymentMethodId,
            customerName: customerName,
            displayCurrencyIso: displayCurrencyIso,
            mobileCountryCode: mobileCountryCode,
            customerMobile: customerMobile,
            customerEmail: customerEmail,
            invoiceValue: invoiceValue,
            callBackUrl: callBackUrl,
            errorUrl: errorUrl,
            language: language,
            customerReference: customerReference
        }
    );
}

export function executePaymentAsync(
    context: IContext,
    paymentMethodId: number,
    customerName: string,
    displayCurrencyIso: string,
    mobileCountryCode: string,
    customerMobile: string,
    customerEmail: string,
    invoiceValue: number,
    callBackUrl: string,
    errorUrl: string,
    language: string,
    customerReference: string
): AsyncResult<DataServiceEntities.IExecutePaymentResponse> {
    const request = createExecutePaymentInput(
        paymentMethodId,
        customerName,
        displayCurrencyIso,
        mobileCountryCode,
        customerMobile,
        customerEmail,
        invoiceValue,
        callBackUrl,
        errorUrl,
        language,
        customerReference
    );
    return callActionOrExecute<DataServiceEntities.IExecutePaymentResponse>(request, context.callerContext);
}
